import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from './reduxHooks';
import { checkActiveVerification } from '../store/slices/emailVerificationSlice';

/**
 * Hook to restore email verification state on app load.
 *
 * Checks for any in-progress verification requests when the user
 * first loads the app or refreshes the page. If found, restores
 * the verification state and resumes polling.
 *
 * This ensures users don't lose track of their verification progress
 * if they refresh the page during processing.
 */
export const useEmailVerificationInit = () => {
  const dispatch = useAppDispatch();
  const { activeVerification } = useAppSelector((state) => state.emailVerification);
  const { isAuthenticated } = useAppSelector((state) => state.auth);

  useEffect(() => {
    // Only check once when user is authenticated and no active verification exists
    if (isAuthenticated && !activeVerification) {
      dispatch(checkActiveVerification());
    }
  }, [dispatch, isAuthenticated, activeVerification]);
};
